var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFinances24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_finances24x24",
    transform: "translate(-21.835 -200)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M160.369,21.3l6.347-2.058-.336-.807a.835.835,0,0,0-1.2-.48L159.5,21.3Z",
    transform: "translate(-134.788 182.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M328.28,86.46a.691.691,0,0,0-.236.042l-1.491.54L322,88.688h7.422l-.279-1.354a.975.975,0,0,0-.863-.874Z",
    transform: "translate(-294.354 114.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M14.186,215.56H.9a.9.9,0,0,0-.868.66.92.92,0,0,0-.032.234v9.96a.9.9,0,0,0,.9.894H14.184a.9.9,0,0,0,.9-.894V223.92H9.747A1.525,1.525,0,0,1,8.22,222.4v-1.988a1.522,1.522,0,0,1,1.526-1.518h5.336v-2.44a.889.889,0,0,0-.261-.632.9.9,0,0,0-.634-.262Z",
    transform: "translate(21.834 -11.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M499.225,437a.893.893,0,0,0-.313-.186.911.911,0,0,0-.289-.049h-5.33a.894.894,0,0,0-.894.894v1.99a.894.894,0,0,0,.894.894h5.33a.911.911,0,0,0,.289-.049.867.867,0,0,0,.313-.186.891.891,0,0,0,.291-.66v-1.99a.891.891,0,0,0-.291-.66Zm-4.069,1.833a.448.448,0,0,1-.447.447h-.3a.448.448,0,0,1-.447-.447v-.3a.442.442,0,0,1,.172-.354.452.452,0,0,1,.275-.1h.3a.447.447,0,0,1,.447.447v.3Z",
    transform: "translate(-461.681 -228.805)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFinances24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_finances24x24.62542738e8c6391adc0f2759fb54e9d2.svg";